<div class="row">
  <div class="col-md-8 col-md-offset-2">
    <p-card [header]="'key_model'| translation">


      <div class="row" *ngFor="let key of currentKeys; let oddRow = odd">
        <div class="col-md-12 row-list" [class.striped]="oddRow">

            <a routerLink='/data-models/{{modelId}}/{{key.name}}/components'>{{ key.name }}</a>
            <p-button severity="info" variant="text" (click)="removeKey(key.name)" class="float-right">
              <i class="fat fa-trash-alt"></i>
            </p-button>

            <p-button severity="info" variant="text" (click)="updateKey(key)" class="float-right">
              <i class="fas fa-edit" *ngIf="keyUpdated[idx]"></i>
            </p-button>
          </div>

        </div>


    </p-card>
  </div>
</div>

<div class="row margin-bottom-lg">
  <div class="col-md-8 col-md-offset-2 padding-bottom-std">
    <label>{{'key_add'| translation}}
    </label>
    <p-inputgroup>
      <input pInputText type="text" #newKeyName="ngModel" noWhiteSpace [(ngModel)]="newKey.name" [name]="newKey.name">
      <p-inputgroup-addon>
        <button pButton severity="primary" (click)="addKey()" [disabled]="alreadyExists() || newKeyName.invalid">
          {{'add'| translation}}
        </button>
      </p-inputgroup-addon>
    </p-inputgroup>
    <div class="error-msg" *ngIf="alreadyExists()">{{'key_name_unique'| translation}}.</div>

    <div class="error-msg" *ngIf="newKeyName.errors && newKeyName.errors.noWhiteSpace">{{'key_name_no_white_spaces'| translation}}.</div>
  </div>
</div>
<div class="row">
  <div class="col-md-8 col-md-offset-2 padding-bottom-std">
    <button pButton (click)="deleteModel()" severity="secondary" class="margin">{{'model_delete'| translation}}</button>
  </div>
</div>
